import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import colors from 'tailwindcss/colors';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  // Observable string sources
  private readonly emitChangeSource = new Subject<any>();

  // Observable string streams
  readonly changeEmitted$ = this.emitChangeSource.asObservable();

  // Service message commands
  emitChange(change: any): void {
    this.emitChangeSource.next(change);
  }

  getRandomThemeColor():string {
    const colorsFilteredKeys = ['gray', 'blue', 'red', 'purple', 'yellow'];
    const colorsFiltered = colorsFilteredKeys.reduce((obj, key) => ({ ...obj, [key]: colors[key] }), {});

    const colorsVariantFilteredKeys = ['400', '500', '600'];
    //const colorsVariantFiltered = colorsVariantFilteredKeys.reduce((obj, key) => ({ ...obj, [key]: colorsFiltered[key] }), {});

    let color = colorsFiltered[colorsFilteredKeys[colorsFilteredKeys.length * Math.random() << 0]];
    let colorVariant = color[colorsVariantFilteredKeys[colorsVariantFilteredKeys.length * Math.random() << 0]];
    return colorVariant;
  }

  setRandomThemeColorText(text: string):string[] {
    let wordCount = text.split(',').length;
    let i = 0;
    let color = '';
    let colors = [];

    do {
      color = this.getRandomThemeColor();

      if (!colors.includes(color)) {
        colors.push(color);
        i++;
      }
    }
    while (i < wordCount);

    return colors;
  }
}
